import './Me.css';
import { useEffect } from 'react';
import { useOutletContext } from "react-router-dom";
import { Avatar, Badge, Button, Card } from '../ds';

export default function Me() {
    const login = localStorage.getItem("login");
    const me = JSON.parse(localStorage.getItem("me"));
    const { setOpenExitModal } = useOutletContext();

    useEffect(() => {
        document.title = "Личный кабинет — WAve";
    }, []);

    if (!me) return <div>Загрузка...</div>;

    const info = me.userInfo || {};
    const role = info.role;
    const created = info.created_at ? new Date(info.created_at) : null;
    const createdAt = created && !Number.isNaN(created.getTime())
        ? created.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
        : '—';

    const rows = [
        ['Email', info.email],
        ['Телефон', info.phoneNumber],
        ...(role === "Партнер" ? [['Партнёр', info.partnerName || 'Не привязан']] : []),
        ['В системе с', createdAt],
    ];

    return (
        <div className="me">
            <Card flush>
                <div className="me-head">
                    <Avatar name={info.name || login} size={64} />
                    <div className="me-titles">
                        <h2 className="ds-h2">{info.name || login}</h2>
                        <span className="ds-small">@{login}</span>
                    </div>
                    {role && <Badge tone="accent">{role}</Badge>}
                </div>

                <dl className="me-details">
                    {rows.map(([key, value]) => (
                        <div className="me-row" key={key}>
                            <dt className="ds-caption">{key}</dt>
                            <dd className="ds-text">{value || '—'}</dd>
                        </div>
                    ))}
                </dl>

                <div className="me-foot">
                    <Button variant="danger-ghost" icon="logout" onClick={() => setOpenExitModal(true)} className="me-exit">
                        Выйти из аккаунта
                    </Button>
                </div>
            </Card>
        </div>
    );
}
